/**
 * Soft clinical-conflict rules for coded directives. Shared by the manual picker
 * (selection-time warning) and the detail page (flagging contradictory OCR
 * candidates on a record). Never a hard block — a clinician adjudicates.
 */

// Cross-category contradictions, by category_code (e.g. Full Code + DNR).
export const CONFLICT_PAIRS = [
  ["full_code", "dnr"],
  ["full_code", "dni"],
  ["full_code", "dnr_dni"],
  ["full_code", "comfort_measures"],
  ["full_code", "dnh"],
];

export const CONFLICT_MESSAGE =
  "These directives may be clinically contradictory. The signing clinician will review — you can still continue.";

/**
 * @param {string[]} categoryCodes category codes present on a record/selection
 * @returns {boolean} true if any contradictory pair, or two in one category
 *   (mutually exclusive), are present.
 */
export function hasConflict(categoryCodes) {
  const cats = Array.isArray(categoryCodes) ? categoryCodes.filter(Boolean) : [];
  for (const [a, b] of CONFLICT_PAIRS) {
    if (cats.includes(a) && cats.includes(b)) return true;
  }
  const seen = new Set();
  for (const c of cats) {
    if (seen.has(c)) return true; // two choices in the same (exclusive) category
    seen.add(c);
  }
  return false;
}
